import { useEffect, useState } from "react";
import API from "../../api/axiosConfig";
import RegisterTextBox from "../../components/RegisterTextBox";
import { useParams } from "react-router";
import "./ProjectKPI.css";
import Title from "../../components/title";
import TestPreLoader from "../TestPreLoader/TestPreLoader";
function ProjectKPI({ projectId }) {
  const [kpis, setKpis] = useState([]);
  const [loading, setLoading] = useState(true);
  const { id } = useParams();

  const getKpis = async () => {
    try {
      const res = await API.get(`/kpi/quizs`);
      setKpis(res.data);
    } catch (error) {
      console.error("There was an error!", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getKpis();
  }, []);

  const calculateStatus = (actual, target) => {
    if (actual === null || actual === "") return null;
    if (+actual >= target) return "ممتاز";
    if (+actual >= target * 0.8) return "تحذير";
    return "خطر";
  };

  const handleChange = (index, value) => {
    const updated = [...kpis];

    updated[index].actual = value;
    updated[index].status = calculateStatus(value, updated[index].target);

    setKpis(updated);
  };
console.log(kpis);
  const handleSubmit = (e) => {
    e.preventDefault();

    API.post(`projectkpi/store`, {
      id: id,
      kpis: kpis.map((k) => ({
        kpi_id: k.id,
        actual: k.actual,
      })),
    });
  };

  if (loading) return <TestPreLoader />;

  return (
    <form onSubmit={handleSubmit}>
      <Title
        title="مؤشرات الاداء"
        style={{ width: "unset", marginBottom: "20px" }}
      />
      <br />
      {kpis.map((kpi, index) => (
        <div key={kpi.id} className="kpi-row">
          <RegisterTextBox
            parentStyle={{ width: "100%" }}
            id="vacDescription"
            label="المؤشر"
            value={kpi.quiz}
            stylee={{ width: "45%" }}
            disabled={true}
          />

          <RegisterTextBox
            parentStyle={{ width: "60%" }}
            id="vacDescription"
            label="القيمةالمتوقعة"
            value={kpi.target}
            stylee={{ width: "45%" }}
            disabled={true}
          />

          <RegisterTextBox
            parentStyle={{ width: "60%" }}
            id="vacDescription"
            label="القيمة الحالية"
            value={kpi.actual}
            stylee={{ width: "45%" }}
            onChange={(e) => handleChange(index, e.target.value)}
          />

          {/* <span className={`status ${kpi.status}`}>
            {kpi.status ?? "-"}
          </span> */}
          <RegisterTextBox
            parentStyle={{ width: "60%" }}
            id="vacDescription"
            label="الحالة"
            value={kpi.status}
            stylee={{ width: "45%" }}
            disabled={true}
            className={`status ${kpi.status}`}
          />
        </div>
      ))}
      <div
        style={{ display: "flex", justifyContent: "center", marginTop: "20px" }}
      >
        <button type="submit" variant="primary" className="btn btn-primary">
          حفظ القيم
        </button>
      </div>
    </form>
  );
}

export default ProjectKPI;
